import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import ContactCTA from "../components/ContactCTA";
import UniqueApproach from "../components/UniqueApproach";
import Testimonials from "../components/Testimonials";
import ServiceSection from "../components/ServiceSection";
import { useLanguage } from "../context/LanguageContext";

const Home = () => {
  const [logoVisible, setLogoVisible] = useState(true);
  const { t } = useLanguage();

  useEffect(() => {
    const timer = setTimeout(() => setLogoVisible(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  const handleCalendlyOpen = () => {
    window.open("https://calendly.com/ir-accounting-info", "_blank");
  };

  return (
    <div className="relative min-h-screen w-full text-gray-800 font-sans overflow-hidden bg-white">
      {logoVisible && (
        <motion.div
          initial={{ opacity: 1, scale: 1 }}
          animate={{ opacity: 0, scale: 1.2 }}
          transition={{ duration: 1.5, ease: "easeOut" }}
          className="fixed inset-0 flex items-center justify-center bg-white z-50"
        >
          <img
            src="/assets/logos/logo-dark.png"
            alt={t("common.logoAlt")}
            className="w-3/4 md:w-1/2 lg:w-1/2 h-auto"
          />
        </motion.div>
      )}

      <motion.div
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 2 }}
        className="relative flex flex-col items-center justify-center text-center min-h-screen py-40 px-6 space-y-6 bg-gray-100"
      >
        <motion.img
          src="/assets/logos/logo-dark.png"
          alt={t("common.logoAlt")}
          className="w-60 h-auto drop-shadow-lg"
          initial={{ scale: 0.8 }}
          animate={{ scale: 1 }}
          transition={{ duration: 1 }}
        />
        <h1 className="text-6xl font-extrabold tracking-wide text-gray-900">{t("home.heroTitle")}</h1>
        <p className="text-lg max-w-2xl text-gray-700 leading-relaxed">{t("home.heroSubtitle")}</p>
        <motion.button
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.95 }}
          onClick={handleCalendlyOpen}
          className="mt-6 bg-gradient-to-r from-yellow-400 to-yellow-500 text-black font-bold py-4 px-10 rounded-xl shadow-lg transition-all duration-300"
        >
          {t("home.heroButton")}
        </motion.button>
      </motion.div>

      <ServiceSection />
      <UniqueApproach />
      <Testimonials />
      <ContactCTA />
    </div>
  );
};

export default Home;
